import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchFeatureFlags, updateFeatureFlag } from "../../actions/callrecorder/featureFlagsActions";

export interface FeatureFlagInterface {
  id: number;
  name: string;
  description: string | null;
  default_enabled: boolean;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0
};

const adaptor = createEntityAdapter<FeatureFlagInterface>();

const slice = createSlice({
  name: 'featureFlags',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureFlags.pending, (state, _action) => {
        state.status = 'loading';
      })
      .addCase(fetchFeatureFlags.fulfilled, (state, action) => {
        state.count    = action.payload.count;
        state.entities = action.payload.featureFlags;
        state.ids      = action.payload.ids;
        state.status   = 'succeeded';
      })
      .addCase(fetchFeatureFlags.rejected, (state, action) => {
        state.status = 'failed';
        state.error  = action.error.message || 'Unknown Error';
      })

      .addCase(updateFeatureFlag.fulfilled, (state, action) => {
        const flag = action.payload?.featureFlag && Object.values(action.payload.featureFlag)[0];
        if (flag) {
          state.entities[flag.id] = flag;
        }
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectFeatureFlagById,
  selectIds: selectFeatureFlagIds,
  selectEntities: selectFeatureFlagEntities,
  selectAll: selectAllFeatureFlags,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.featureFlags);
